export const BLACKLISTED_DOMAINS = [
  'tuamaeaquelaursa.com',
  'tempmail.com',
  '10minutemail.com',
  'fakeinbox.com',
  'mailinator.com',
  'guerrillamail.com',
  'dispostable.com',
  'maildrop.cc',
  'getnada.com',
  'mytemp.email',
  'yopmail.com',
  'mailnesia.com',
  'temp-mail.org',
  'emailondeck.com',
  'throwawaymail.com',
  'moakt.com',
  'burnermail.io',
  'mailbox.org',
  'spambog.com',
  'sharklasers.com',
  'mailcatch.com',
  'inboxalias.com',
  'spamgourmet.com',
  'tmail.ws',
  'emailsensei.com',
  'getairmail.com',
  'anonbox.net',
  'mohmal.com',
  'mintemail.com',
  'dropmail.me',
  'tempail.com',
  'guerillamail.net',
  'disposablemail.com',
  'mailsac.com',
  'mail.tm',
  'mail1a.de',
  'fakemailgenerator.com',
  'trashmail.com',
]
